import topicsServices from '@/services/topics.services.js';
import storage from '@/plugins/storage.plugins.js';
import sections from "@/constants/sections.enum.js";
import mixin from "@/mixin/index.js";
const { _removeAccents, _isCordovaApp, _isMobile, _getLabel } = mixin.methods;
const root = { root: true };

export default {
    async clinicalHandoutsHomeClick({ dispatch }) {
        try {
            dispatch("general/logEvent", { name: "clinicalHandoutsHomeClick" }, root);
            return dispatch('general/routePathRedirect', { path: '/handouts' }, root);
        } catch {
            dispatch("general/showError", null, root);
        }
    },
    async homeTopicClick({ state, dispatch }, id) {
        try {
            dispatch("drugs/clearNavigationHistory", null, root);
            state.topic = sections['sections'].find(s => {
                return s.id == id;
            });
            const logEvent = `homeTopicClick_${id}`;
            dispatch("general/logEvent", { name: logEvent }, root);
            return dispatch('general/routePathRedirect', { path: `/topics/${id}` }, root);
        } catch {
            dispatch("general/showError", null, root);
        }
    },
    async openTopic({ dispatch, commit, state, rootGetters }, id) {
        try {
            if (['foods', 'oral_hygiene', 'supplements'].includes(id)) {
                return dispatch('openLegacyCategoriesItem', id);
            } else if (id === 'clinical_handouts') {
                state.items = [];
                const { clinicalHandouts } = await topicsServices.getTopic(id);
                state.items = clinicalHandouts.sort(function (a, b) {
                    return _removeAccents(a['name'].toLowerCase()) > _removeAccents(b['name'].toLowerCase()) ? 1 : -1;
                });
                return [...state.items];
            }
            commit('drugs/setCategory', {
                id,
                collection: id,
                productsCollection: id,
                hideBrandSelection: true,
            }, root);
            if (!!rootGetters['drugs/drugsSummary'] && !!rootGetters['drugs/drugsSummary'][id]) {
                return;
            }
            dispatch("general/logEvent", { name: "openTopic", object: { id } }, root);
            const { items } = await topicsServices.getTopic(id);
            state.topic = sections.sections.find(s => {
                return s.id == id;
            });
            let summary = {};
            summary[id] = items;
            if (!items.length) {
                dispatch('general/routeBack', null, root);
                return dispatch('preferences/postFakeDoorClick', id, root);
            }
            commit('drugs/setDrugsSummary', summary, root);
            let summaryProdutcs = {}
            summaryProdutcs[id] = [];
            commit('drugs/setProductsSummary', summaryProdutcs, root);
        } catch (err) {
            dispatch("general/showError", null, root);
            dispatch('general/routeRedirect', { name: 'home' }, root);
        }
    },
    async openTopicItem({ commit, dispatch, state, rootGetters }, { itemId, topicId = 'topics', redirectMode = false }) {
        try {
            if (!redirectMode || topicId === 'calculators') {
                dispatch("general/logEvent", { name: 'openTopicItemById', object: { id: itemId } }, root);
                commit("general/setLoadingOn", true, root);
                const stateHasItem = !!state.item && state.item.id === itemId;

                if (rootGetters['management/algorithm']) {
                    state.item = rootGetters['management/algorithm'];
                } else if (!stateHasItem) {
                    const response = await topicsServices.getItem(topicId, itemId);
                    if (topicId !== 'calculators') {
                        state.item = response;
                        setReferencesFromItem(state, commit);
                    }
                }

                if (topicId !== 'calculators') {
                    state.topic = sections.sections.find(s => {
                        return s.id == state.item.topic;
                    });
                    if (state.item.tree) {
                        dispatch('algorithms/openAlgorithmByIdAsync', { tree: state.item.tree, treeLoaded: stateHasItem }, root);
                    } else {
                        dispatch("general/logEvent", `open_${state.topic.id}`, root);
                    }
                }
            } else {
                dispatch('general/routePathRedirect', { path: `/item/${itemId}` }, root);
            }
            return true;
        } catch (err) {
            if (!!err && !!err.response && err.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                console.log(err)
                dispatch("general/showError", null, root);
            }
            if (!redirectMode) {
                dispatch('general/routeBack', null, root);
            }
            return false;
        } finally {
            commit("general/setLoadingOff", true, root);
        }
    },
    async openLegacyCategoriesItem({ state, dispatch, commit, rootGetters }, id) {
        try {
            state.topic = sections.sections.find(s => {
                return s.id == id;
            });
            commit('drugs/setDrugsSummary', { [id]: [] }, root);
            commit('drugs/setProductsSummary', {
                [id]: await storage.storageSelect(id)
            }, root);

            commit('drugs/setCategory', {
                id,
                collection: id,
                productsCollection: id,
                hideBrandSelection: true,
                orderByPhotos: true,
                orderByClasses: false,
            }, root);
            state.summaryId = id;
        } catch (error) {
            dispatch("general/showError", null, root);
            dispatch('general/routeRedirect', { name: 'home' }, root);
        }

    },
    async openDiseasesFullApproach({ state, dispatch, commit, rootGetters }) {
        const { id, treatment } = state.item;
        if (treatment) {
            return dispatch("preferences/postFakeDoorClick", 'DISEASES_FULL_APPROACH', root);
        }
        dispatch("general/routePathRedirect", {
            path: `/item/${id.replace("treatment&", "")}`,
        }, root);
    },
    async shareClinicalHandouts({ state, dispatch, rootGetters }, { phone, email, ownerId, patientId, type }) {
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'shareClinicalHandouts',
            action: async () => {
                const date = new Date().toLocaleString("pt-BR");
                const clinicalHandouts = Object.keys(state.clinicalHandouts).filter(key => state.clinicalHandouts[key]);
                const { link } = await topicsServices.shareClinicalHandouts(
                    { clinicalHandouts, phone, email, ownerId, patientId, types: [type], date }
                );
                const SHARE_ACTIONS = {
                    EMAIL: 2,
                    WHATSAPP: 3,
                    COPY: 5,
                };

                if (type === SHARE_ACTIONS.WHATSAPP) {
                    const doctorName = rootGetters['general/user'].displayName;
                    phone = phone.replace(/[\s\(\)\-\.\+]/g, '');
                    const encodedText = encodeURIComponent(`${doctorName} enviou seus folhetos informativos. Acesse pelo link: ${link}`);
                    dispatch("general/openWhatsapp", {
                        phone,
                        text: encodedText
                    }, root);
                } else if (type === SHARE_ACTIONS.EMAIL) {
                    dispatch("general/showMessage", null, root);
                } else if (type === SHARE_ACTIONS.COPY) {
                    dispatch("general/copyToClipboard", link, root);
                }
                return true;
            },
            errorAction: () => {
                dispatch("general/showError", null, root);
                return false;
            },
            showMessage: false
        }, root);
    },
    async getSharedClinicalHandouts({ state, dispatch, commit }, { token }) {
        try {
            dispatch("general/logEvent", { name: "getSharedClinicalHandouts" }, root);
            commit("general/setLoadingOn", null, root);
            return await topicsServices.getSharedClinicalHandouts(token);
        } catch (error) {
            return { clinicalHandouts: null }
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async postClinicalHandoutsAlgorithmsClickEvent({ dispatch }, { token, inputs, latitude = null, longitude = null }) {
        try {
            inputs = typeof inputs !== 'string' ? JSON.stringify(inputs) : inputs;
            dispatch("general/logEvent", { name: "clinicalHandoutsAlgorithmsClick" }, root);
            return await topicsServices.postClinicalHandoutsAlgorithmsClickEvent(token, inputs, latitude, longitude);
        } catch {
            dispatch("general/logEvent", { name: "errorClinicalHandoutsAlgorithmsClick" }, root);
        }
    },

    async loadConversations({ commit, dispatch, rootGetters }) {
        try {
            const data = await topicsServices.getConversations();
            commit('setConversations', data.items || []);
            commit('setConversationsNextCursor', data.nextCursor || null);
        } catch (err) {
            if (!!err && !!err.response && err.response.status == 403) {
                commit('general/setConfirmModel', {
                    text: err.response.data.message,
                    callback: () => {
                        if (!rootGetters['general/isPremium']) {
                            dispatch("purchases/openPurchases", null, root);
                        }
                    },
                    confirmText: _getLabel("CONTINUE"),
                    alert: true,
                }, root);
            } else {
                dispatch("general/showError", null, root);
            }
        }
    },

    async loadMoreConversations({ state, commit, dispatch }) {
        try {
            if (!state.conversationsNextCursor) return;
            const data = await topicsServices.getConversations(state.conversationsNextCursor);
            commit('appendConversations', data.items || []);
            commit('setConversationsNextCursor', data.nextCursor || null);
        } catch {
            dispatch("general/showError", null, root);
        }
    },

    async openConversation({ commit, dispatch }, { id }) {
        try {
            const data = await topicsServices.getConversation(id);
            commit('setConversation', data);
            return data;
        } catch (err) {
            dispatch("general/showError", null, root);
            return null;
        }
    },

    async sendMessage({ state, commit, dispatch }, { conversationId, message, context, files }) {
        try {
            const now = Date.now();
            const attachments = Array.isArray(files)
                ? files.map((f) => ({ name: f.name, mimeType: f.mimeType, size: f.size }))
                : [];
            if (state.conversation) {
                const messages = [...(state.conversation.messages || [])];
                messages.push({ role: 'user', content: message, attachments, timestamp: now });
                commit('setConversation', {
                    ...state.conversation,
                    messages,
                    status: 'processing',
                });
            }
            const data = await topicsServices.postConversationMessage({ conversationId, message, context, files });
            return data;
        } catch (err) {
            if (!!err && !!err.response && err.response.status == 409) {
                dispatch("general/showError", null, root);
            } else if (!!err && !!err.response && err.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                dispatch("general/showError", null, root);
            }
            return null;
        }
    },

    async deleteConversation({ commit, dispatch }, { id }) {
        try {
            await topicsServices.deleteConversation(id);
            commit('removeConversation', id);
        } catch {
            dispatch("general/showError", null, root);
        }
    },

    async pollConversation({ commit, dispatch }, { id }) {
        try {
            const data = await topicsServices.getConversation(id);
            commit('setConversation', data);
            return data;
        } catch {
            return null;
        }
    },

}

function setReferencesFromItem(state, commit) {
    for (let section of state.item.sections) {
        if (!state.item.references) {
            delete section.references;
        } else if (!!section.references && typeof section.references == 'string') {
            const referencesValue = `${section.references}`;
            section.references = [];
            if (referencesValue.includes('@')) {
                let [start, end] = referencesValue.split('@');
                for (let i = parseInt(start); i <= parseInt(end); i++) {
                    const ref = state.item.references.find(r => { return r.index == i; });
                    if (ref) {
                        section.references.push(ref);
                    }
                }
            } else {
                referencesValue.split(';').forEach(refNumber => {
                    if (refNumber) {
                        const ref = state.item.references.find(r => { return r.index == parseInt(refNumber); });
                        if (ref) {
                            section.references.push(ref);
                        }
                    }
                });
            }
        }
    }
    state.itemContent = null;
    commit('setClickedReferences', []);
}
